// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/canvas/tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCanvasTags } from "./constants";
import type { EngagementCanvasTagsResult } from "./types";

export const getEngagementCanvasTags = reactQueryFetcherAdapter(
  engagementCanvasTags,
  (signal: AbortSignal, appGroupId: string, showIds = false): Promise<EngagementCanvasTagsResult> => {
    return fetch("/engagement/canvas/tags", "GET", { app_group_id: appGroupId, show_ids: showIds }, { signal });
  }
);
